import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import Select, {AsyncSelect} from '@atlaskit/select';

export default class FieldSelect extends PureComponent {
  static propTypes = {
    keyName: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    data: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        id: PropTypes.any,
      })
    ),
    name:  PropTypes.string,
    required: PropTypes.bool,
    fetching: PropTypes.bool,
    getData: PropTypes.func,
    onChange: PropTypes.func,
    asyncMethodName: PropTypes.string,
    isMulti: PropTypes.bool,
  };

  static defaultProps = {
    isMulti: false,
    getData: () => console.log('Filter_getData'),
    onChange: (fieldName, value) => console.log('Filter_onChange', {[fieldName]:value}),
  }

  constructor(props){
    super(props);
    this.timeout =  0;
  }

  componentDidMount() {
    /* Не работает
    const {
      name,
      required,
    } = this.props;
    if (required) {
      const input = document.getElementsByName(name);
      console.log("select",name, required, input, input.length, input[0]);
      if (input && input.length && input[0]) {
        input[0].setAttribute("required", "");
        input[0].style.opacity = 0;
        input[0].style.width = "0px";
        input[0].style.height = "0px";
        input[0].style.float = "left";
        input[0].style.margin = "0px";
        input[0].style.padding = "0px";
        input[0].setAttribute("type", "text");
        console.log("select / set hidden");
      }
    }
    */
    const {data, getData} = this.props;
    if (!data && getData) {
      getData();
    }
  }

  onSelectChange = options => {
    const {keyName, onChange} = this.props;
    const value = options && options.length > 0
      ? options.map(option => option.id)
      : null;
      
    onChange(keyName, this.props.isMulti ? value : options);
  }

  async getOptions(inputValue) {
    if (!inputValue) {
      return [];
    }
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}dic/${this.props.asyncMethodName}?query=${inputValue}`
    );
    const data = await response.json();
    return data;
  }
 
  render() {
    const {
      placeholder,
      fetching,
      asyncMethodName,
      ...otherProps
    } = this.props;

    const Element = asyncMethodName ? AsyncSelect : Select;
    const data = this.props.data ? [...this.props.data] : null; //Не работает с mutable array
    return (
      <Element
        options={data}
        placeholder={placeholder}
        isDisabled={!data}
        isLoading={fetching}
        getOptionLabel={({name}) => name}
        getOptionValue={({id}) => id}
        loadOptions={this.getOptions}
        {...otherProps}
        onChange={this.onSelectChange}
      />
    );
  }
}
